var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export var TextGroup = function (_a) {
    var _b;
    var className = _a.className, density = _a.density, deep = _a.deep, children = _a.children, rest = __rest(_a, ["className", "density", "deep", "children"]);
    return (_jsx("div", __assign({ className: classNames("eds-text-group", (_b = {},
            _b["eds-text-group--".concat(density)] = density === "high" || density === "low",
            _b["eds-text-group--deep"] = deep,
            _b), className) }, rest, { children: children })));
};
